// React
import React, { useState, useEffect, useRef } from "react";

// Ionic
import {
  IonLabel,
  IonItem,
  IonContent,
  IonHeader,
  IonToolbar,
  IonButton,
  IonIcon,
  IonCheckbox,
  IonRange,
  IonRadio,
  IonRadioGroup,
  IonModal,
  IonAccordion,
  IonAccordionGroup,
  IonRow,
  IonCol,
  IonLoading,
} from "@ionic/react";

import {
  options,
  closeOutline,
  informationCircleOutline,
  add,
  search,
} from "ionicons/icons";

import userService from "../../Context/user.service";
import { act } from "react-dom/test-utils";
//CSS

function Filter(props) {
  const handleFilterClick = (e) => {
    props.onFilterClick(e.target.value);
  };

  const handleFilterFakeClick = function () {
    props.onFilterClick("dog");
  }

  const handleGratisClick = function () {
    if(props.forfreeValue) {
      props.setForfree(false);
    }
    else {
      props.setForfree(true);
    }
  }

  // Modal dunctions
  const modal = useRef(null);
  const input = useRef(null);
  const [isLoaded, setIsLoaded] = useState(true);
  const [plusModalOpen, setPlusModalOpen] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [activePlusFilter, setActivePlusFilter] = useState();

  const plusfilterArray = [
    "Stellplätze an Urigen Brauereien",
    "Stellplätze an Bauernhöfen",
    "Stellplätze Romantische Städte 1",
    "Stellplätze Romantische Städte 2",
    "Stellplätze Schöne Flüsse",
    "Stellplätze Marinas",
    "Stellplätze Burgen & Schlösser",
  ];

  useEffect(() => {
    props.setActiveFilter(props.activeFilter);
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    props.sendSearch();
  }, [filterModalOpen]);  

  function onWillDismiss() {
    setFilterModalOpen(false);
    setPlusModalOpen(false);
  }

  function howtogetpro() {
    if (typeof window.parent.setPaywallModal !== "undefined") {
      window.parent.setPaywallModal("pro");
    }
  }

  function resetFilter() {
    let defaultwerte = {
      address: "",
      features: [],
      underground: [],
      interests: [],
      searchinput: "",
      searchstring: "",
      typePitch: true,
      typeService: true,
      gespanneErlaubt: false,
      voucher: false,
      price: { lower: 0, upper: 30 },
      vehicle_length: { lower: 4, upper: 15 },
      noofpitches: { lower: 1, upper: 40 },
      ve: 0,
    }
    props.setActiveFilter(defaultwerte);
  }

  function prepareFilter() {
    setFilterModalOpen(true);
  }

  function openModalPlus() {
    setPlusModalOpen(true);
  }

  function closeModalPlus() {
    setPlusModalOpen(false);
  }

  function closeModalFilter() {
    setFilterModalOpen(false);
  }

  function setDog() {
    if (props.dogValue === false) {
      props.setDog(true);
      props.setActiveFilter({ ...props.activeFilter, features: [...props.activeFilter.features, "Hunde erlaubt"] });
    }
    else{
      props.setDog(false);
      props.setActiveFilter({ ...props.activeFilter, features: props.activeFilter.features.filter(f => f !== "Hunde erlaubt") });
    }
  }

  function setDisposal() {
    if (props.disposalValue === false) {
      props.setDisposal(true);
      props.setActiveFilter({ ...props.activeFilter, features: [...props.activeFilter.features, "Frischwasser", "Chemietoiletten-Entsorgung", "Grauwasser-Entsorgung"] });
    } else {
      props.setDisposal(false);
      props.setActiveFilter({ ...props.activeFilter, features: props.activeFilter.features.filter(f => f !== "Frischwasser" && f !== "Chemietoiletten-Entsorgung" && f !== "Grauwasser-Entsorgung") });
    }
  }

  function setForfree() {
    if (props.forfreeValue === false) {
      props.setForfree(true);
      props.setActiveFilter({ ...props.activeFilter, price: { lower: 0, upper: 0 } });
    } else {
      props.setForfree(false);
      props.setActiveFilter({ ...props.activeFilter, price: { lower: 0, upper: 30 } });
    }
  }

  function selectPlusFilter(filter) {
    setActivePlusFilter(filter);

    // Define the URL
    const url = new URL(window.location.href);
    url.pathname = "/map/home";
    const params = new URLSearchParams();
    url.hash = "nosearch";
    if (filter === "Stellplätze an Urigen Brauereien") {
      if (props.isLoggedInValue) {
        if (
          userService.checkPlenigoAccessItem([
            "FilterBrauereien",
            "FilterundContentBrauereien",
          ])
        ) {
          params.append("special", "Urige Brauereien");
          url.search = params.toString();
          window.location.href = decodeURIComponent(url.href);
        } else {
          window.parent.setPaywallModal("2");
        }
      } else {
        window.parent.setPaywallModal("2");
      }
    } else if (filter === "Stellplätze an Bauernhöfen") {
     if (props.isLoggedInValue) { 
         if (
          userService.checkPlenigoAccessItem([
            "FilterBauernhoefe",
            "FilterundContentBauernhoefe",
          ])
        ) { 
          params.append("special", "Bauernhöfe");
          url.search = params.toString();
          window.location.href = decodeURIComponent(url.href);
        } else {
           window.parent.setPaywallModal("4");
         }
      } else {
        window.parent.setPaywallModal("4");
      }
    } else if (filter === "Stellplätze Romantische Städte 1") {
      if (props.isLoggedInValue) {
        if (
          userService.checkPlenigoAccessItem([
            "FilterStaedte1",
            "FilterundContentStaedte1",
          ])
        ) {
          params.append("special", "Romantische Städte I");
          url.search = params.toString();
          window.location.href = decodeURIComponent(url.href);
        } else {
          window.parent.setPaywallModal("17");
        }
      } else {
        window.parent.setPaywallModal("17");
      }
    } else if (filter === "Stellplätze Romantische Städte 2") {
      if (props.isLoggedInValue) {
        if (userService.checkPlenigoAccessItem(["FilterStaedte2"])) {
          params.append("special", "Romantische Städte II");
          url.search = params.toString();
          window.location.href = decodeURIComponent(url.href);
        }else {
          window.parent.setPaywallModal("18");
        }
      } else {
        window.parent.setPaywallModal("18");
      }
    } else if (filter === "Stellplätze Schöne Flüsse") {
      if (props.isLoggedInValue) {
        if (userService.checkPlenigoAccessItem(["FilterFluesse"])) {
          params.append("special", "Flüsse");
          url.search = params.toString();
          window.location.href = decodeURIComponent(url.href);
        } else {
          window.parent.setPaywallModal("18");
        }
      } else {
        window.parent.setPaywallModal("19");
      }
    } else if (filter === "Stellplätze Marinas") {
      if (props.isLoggedInValue) {
        if (userService.checkPlenigoAccessItem(["FilterMarinas"])) {
          params.append("special", "Marinas");
          url.search = params.toString();
          window.location.href = decodeURIComponent(url.href);
        } else {
          window.parent.setPaywallModal("16");
        }
      } else {
        window.parent.setPaywallModal("16");
      }
    } else if (filter === "Stellplätze Burgen & Schlösser") {
      if (props.isLoggedInValue) {
        if (userService.checkPlenigoAccessItem(["FilterBurgen"])) {
          params.append("special", "Burgen und Schlösser");
          url.search = params.toString();
          window.location.href = decodeURIComponent(url.href);
        } else {
          window.parent.setPaywallModal("15");
        }
      } else {
        window.parent.setPaywallModal("15");
      }
    }
  }

  return isLoaded ? (
    <div>
      <div className="filter__wrapper">
        <div>
          {(function () {

            if(window.location.href.indexOf("typ=Entsorgungsstation") === -1) {
              return (
                  <>
                    <IonButton
                        size="small"
                        className="filter__button font__icon "
                        onClick={props.isProValue ? setDog : howtogetpro}
                        value="dog"
                        active="false"
                        color={props.dogValue ? "secondary" : "light"}
                    >
                      <span className="filter__button__icon">h</span>
                    </IonButton>

                    <IonButton
                        size="small"
                        className="filter__button"
                        onClick={props.isProValue ? setDisposal : howtogetpro}
                        value="disposal"
                        active="false"
                        color={props.disposalValue ? "secondary" : "light"}
                    >
                      VE
                    </IonButton>
                    <IonButton
                        size="small"
                        className="filter__button"
                        onClick={props.isProValue ? setForfree : howtogetpro}
                        value="forfree"
                        active="false"
                        color={props.forfreeValue ? "secondary" : "light"}
                    >
                      Gratis
                    </IonButton>
                  </>
              );
            }
          })()}

        </div>
        <div className="filter__wrapper__right">
          {(function () {
            if(window.location.href.indexOf("typ=Entsorgungsstation") === -1) {
              //if (props.isProValue) {
                return (
                    <IonButton
                        size="small"
                        className="filter__button "
                        value="plusfilter"
                        id="plusfilter"
                        color="light"
                        onClick={() => openModalPlus()}
                    >
                      +Filter
                    </IonButton>
                );
              /*
              } else {
                return (
                    <IonButton
                        size="small"
                        className="filter__button "
                        value="plusfilter"
                        id="plusfilter"
                        color="light"
                        onClick={() => howtogetpro()}
                    >
                      +Filter
                    </IonButton>
                );
              }
              */
            }
          })()}

          {(function () {

            if(window.location.href.indexOf("typ=Entsorgungsstation") === -1) {
              if (props.isProValue) {
                var buttonColor = 'light';
                var iconColor = 'medium';
                if (props.filterIsSet() === true) {
                  buttonColor = 'secondary';
                  iconColor = 'light';
                }
                var buttonActive = props.filterIsSet();
                return (
                    <IonButton
                        size="small"
                        className="filter__button filter__modal"
                        id="open-modal"
                        color={buttonColor}
                        active={buttonActive}
                        onClick={(e) => prepareFilter()}
                    >
                      <IonIcon icon={options} color={iconColor}/>
                    </IonButton>
                );
              } else {
                return (
                    <IonButton
                        size="small"
                        className="filter__button filter__modal"
                        id="dont-open-modal"
                        color="light"
                        onClick={(e) => howtogetpro()}
                    >
                      <IonIcon icon={options} color="medium"/>
                    </IonButton>
                );
              }
            }
          })()}
        </div>
      </div>

      <IonModal
        isOpen={plusModalOpen}
        id="plusmodal"
        onWillDismiss={() => onWillDismiss()}
      >
        <IonHeader>
          <IonToolbar>
            <h4 className="ion-padding-start">+Filter ​</h4>
            <IonButton onClick={() => closeModalPlus()} slot="end" fill="clear">
              <IonIcon icon={closeOutline} />
            </IonButton>
          </IonToolbar>
          <IonRow className="ion-align-items-center ">
            <IonCol size="10">
              <p className="ion-padding-start">
                Wähle Deinen +Filter und erhalte redaktionell ausgewählte
                Stellplätze in Deutschland:​ ​
              </p>
            </IonCol>
            <IonCol size="2">
              <button class="btn-filter-plus"
                onClick={() =>
                  userService.goToURL(
                    "/stellplatzplus"
                  )
                }
              >
                <IonIcon icon={informationCircleOutline} size="large" />
              </button>
            </IonCol>
          </IonRow>
        </IonHeader>
        <IonRadioGroup value={activePlusFilter} className="ion-margin-bottom">
          {plusfilterArray.map((item) => {
            return (
              <>
                <IonItem key={item} className="filter__item__accordion">
                  <IonRadio
                    name="plusfilter__radio"
                    value={item}
                    onIonFocus={() => selectPlusFilter(item)}
                  ></IonRadio>
                  <IonLabel className="ion-padding-start">
                    <p className="font__accordion">{item}</p>
                  </IonLabel>
                </IonItem>
              </>
            );
          })}
        </IonRadioGroup>
      </IonModal>

      <div className={`${props.isProValue ? "show" : "hide"}`}>
        <>
          <IonModal
            isOpen={filterModalOpen}
            id="filtermodal"
            onWillDismiss={(ev) => onWillDismiss(ev)}
          >
            <IonHeader>
              <IonLoading
                isOpen={props.loading}
                spinner="crescent"
                message="Bitte warten..."
                backdropDismiss={false}
              />
              <IonToolbar>
                <h4 className="ion-padding-start">Stellplätze filtern</h4>
                <IonButton
                  onClick={() => closeModalFilter()}
                  slot="end"
                  fill="clear"
                >
                  <IonIcon icon={closeOutline} />
                </IonButton>
              </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
              <IonButton
                  size="small"
                  className="filter__button"
                  value="reset"
                  id="reset-search"
                  color={props.filterIsSet() ? "secondary" : "light"}
                  active={props.filterIsSet()}
                  disabled={!props.filterIsSet()}
                  onClick={(e) => resetFilter()}
              >
                Filter zurücksetzen
              </IonButton>


              <IonItem key="type-pitch" className="filter__item__accordion">
                {(function () {
                  if (props.activeFilter.typePitch === true) {
                    return (
                      <IonCheckbox
                        checked
                        name="type-pitch"
                        value="type-pitch"
                        onIonChange={(e) => props.setActiveFilter({ ...props.activeFilter, typePitch: false })}
                      ></IonCheckbox>
                    );
                  } else {
                    return (
                      <IonCheckbox
                        name="type-pitch"
                        value="type-pitch"
                        onIonChange={(e) => props.setActiveFilter({ ...props.activeFilter, typePitch: true })}
                      ></IonCheckbox>
                    );
                  }
                })()}
                <IonLabel className="ion-padding-start">
                  Wohnmobilstellplatz
                </IonLabel>
              </IonItem>

              <IonItem key="gespanneErlaubt" className="filter__item__accordion ion-padding-start">
                {(function () {
                  if (props.activeFilter.gespanneErlaubt === true) {
                    return (
                        <IonCheckbox
                            checked
                            name="gespanneErlaubt"
                            value="gespanneErlaubt"
                            onIonChange={(e) => props.setActiveFilter({ ...props.activeFilter, gespanneErlaubt: false }) }
                        ></IonCheckbox>
                    );
                  } else {
                    return (
                        <IonCheckbox
                            name="gespanneErlaubt"
                            value="gespanneErlaubt"
                            onIonChange={(e) => props.setActiveFilter({ ...props.activeFilter, gespanneErlaubt: true }) }
                        ></IonCheckbox>
                    );
                  }
                })()}
                <IonLabel className="ion-padding-start">
                  Gespanne erlaubt
                </IonLabel>
              </IonItem>

              <IonItem key="type-service" className="filter__item__accordion">
                {(function () {
                  if (props.activeFilter.typeService === true) {
                    return (
                      <IonCheckbox
                        checked
                        name="type-service"
                        value="type-service"
                        onIonChange={(e) => props.setActiveFilter({ ...props.activeFilter, typeService: false }) }
                      ></IonCheckbox>
                    );
                  } else {
                    return (
                      <IonCheckbox
                        name="type-service"
                        value="type-service"
                        onIonChange={(e) => props.setActiveFilter({ ...props.activeFilter, typeService: true }) }
                      ></IonCheckbox>
                    );
                  }
                })()}
                <IonLabel className="ion-padding-start">
                  Entsorgungsstation
                </IonLabel>
              </IonItem>

              <IonItem key="type-voucher" className="filter__item__accordion">
                {(function () {
                  if (props.activeFilter.voucher === true) {
                    return (
                        <IonCheckbox
                            checked
                            name="type-voucher"
                            value="type-voucher"
                            onIonChange={(e) => props.setActiveFilter({ ...props.activeFilter, voucher: false }) }
                        ></IonCheckbox>
                    );
                  } else {
                    return (
                        <IonCheckbox
                            name="type-voucher"
                            value="type-voucher"
                            onIonChange={(e) => props.setActiveFilter({ ...props.activeFilter, voucher: true }) }
                        ></IonCheckbox>
                    );
                  }
                })()}
                <IonLabel className="ion-padding-start">
                  Alle Stellplätze mit BORDATLAS-Gutschein
                </IonLabel>
              </IonItem>

              <p className="font__uppercase font__small">Preis</p>
              <IonItem>
                <IonRange
                  dual-knobs="true"
                  id="price2"
                  onIonKnobMoveEnd={({ detail }) => props.setActiveFilter({ ...props.activeFilter, price: detail.value })}
                  value={{
                    lower: Number(props.activeFilter.price?.lower ?? 0),
                    upper: Number(props.activeFilter.price?.upper ?? 30),
                  }}
                  name="price2"
                  min={0}
                  max={30}
                  color="primary"
                  pin={true}
                  pinFormatter={(value) => `${value} €`}
                >
                  <IonLabel slot="start">Gratis</IonLabel>
                  <IonLabel slot="end">mehr als 30 €</IonLabel>
                </IonRange>
              </IonItem>

              <p className="font__uppercase font__small">Fahrzeuglänge</p>
              <IonItem className="filter__item__noborder">
                <IonRange
                  dual-knobs="true"
                  id="vehicle_length"
                  name="vehicle_length"
                  onIonKnobMoveEnd={({ detail }) => props.setActiveFilter({ ...props.activeFilter, vehicle_length: detail.value })}
                  value={{
                    lower: props.activeFilter.vehicle_length.lower,
                    upper: props.activeFilter.vehicle_length.upper,
                  }}
                  min="5"
                  max="15"
                  color="primary"
                  pin={true}
                  pinFormatter={(value) => `${value} m`}
                >
                  <IonLabel slot="start">Unter 5 m</IonLabel>
                  <IonLabel slot="end">mehr als 15 m</IonLabel>
                </IonRange>
              </IonItem>

              <p className="font__uppercase font__small">Anzahl Stellplätze</p>
              <IonItem>
                <IonRange
                  dual-knobs="true"
                  onIonKnobMoveEnd={({ detail }) => props.setActiveFilter({ ...props.activeFilter, noofpitches: detail.value })}
                  id="noofpitches"
                  name="noofpitches"
                  value={{
                    lower: props.activeFilter.noofpitches.lower,
                    upper: props.activeFilter.noofpitches.upper,
                  }}
                  min="1"
                  max="40"
                  color="primary"
                  pin={true}
                  pinFormatter={(value) => `${value}`}
                >
                  <IonLabel slot="start">1</IonLabel>
                  <IonLabel slot="end">mehr als 40</IonLabel>
                </IonRange>
              </IonItem>

              <IonAccordionGroup>
                <IonAccordion value="first">
                  <IonItem slot="header" className="filter__header__accordion">
                    <IonLabel>
                      <p className="font__uppercase font__small font__red">
                        Versorgung / Entsorgung
                      </p>
                    </IonLabel>
                  </IonItem>
                  <div className="ion-padding" slot="content">
                    {props.versorgung.map((item) => {
                      let itemChecked = false;
                      if (props.activeFilter.features.indexOf(item) !== -1) {
                        itemChecked = true;
                      }
                      return (
                        <>
                          <IonItem
                            key={item}
                            className="filter__item__accordion"
                          >
                            <IonCheckbox
                              checked={itemChecked}
                              name={item}
                              value={item}
                              onIonChange={(e) => {
                                let newVersorgung = [...props.activeFilter.features];
                                if (e.detail.checked) {
                                  if (newVersorgung.indexOf(item) === -1) newVersorgung.push(item);
                                } else {
                                  newVersorgung = newVersorgung.filter(f => f !== item);
                                }
                                props.setActiveFilter({ ...props.activeFilter, features: newVersorgung });
                              }}
                            ></IonCheckbox>
                            <IonLabel className="ion-padding-start">
                              <p className="font__small font__accordion">
                                <p className="font__icon font__small icon__accordion">
                                  {item === "Stromanschlüsse"
                                    ? "n"
                                    : item === "Frischwasser"
                                    ? "q"
                                    : item === "WC"
                                    ? "u"
                                    : item === "Dusche"
                                    ? "J"
                                    : item === "Chemietoiletten-Entsorgung"
                                    ? "k"
                                    : item === "Grauwasser-Entsorgung"
                                    ? "l"
                                    : item === "Müll-Entsorgung"
                                    ? "M"
                                    : ""}
                                </p>
                                {item}
                              </p>
                            </IonLabel>
                          </IonItem>
                        </>
                      );
                    })}
                  </div>
                </IonAccordion>

                <IonAccordion value="second">
                  <IonItem slot="header" className="filter__header__accordion">
                    <IonLabel>
                      <p className="font__uppercase font__small font__red">
                        Ausstattung
                      </p>
                    </IonLabel>
                  </IonItem>

                  <div id="austattung" className="ion-padding" slot="content">
                    {props.austattung.map((item, index) => {
                      let itemChecked = false;
                      if (props.activeFilter.features.indexOf(item) !== -1) {
                        itemChecked = true;
                      }
                      return (
                        <>
                          <IonItem
                            key={item}
                            className="filter__item__accordion"
                          >
                            <IonCheckbox
                              checked={itemChecked}
                              name={item}
                              value={item}
                              onIonChange={(e) => {
                                let newFeatures = [...props.activeFilter.features];
                                if (e.detail.checked) {
                                  if (newFeatures.indexOf(item) === -1) newFeatures.push(item);
                                } else {
                                  newFeatures = newFeatures.filter(f => f !== item);
                                }
                                props.setActiveFilter({ ...props.activeFilter, features: newFeatures });
                              }}
                            ></IonCheckbox>

                            <IonLabel className="ion-padding-start">
                              <p className="font__small font__accordion">
                                <p className="font__icon font__small icon__accordion">
                                  {item === "Einrichtungen für Kinder"
                                    ? "K"
                                    : item === "Rollstuhlgerecht"
                                    ? "f"
                                    : item === "Hunde erlaubt"
                                    ? "h"
                                    : item === "WLAN-Hotspot"
                                    ? "z"
                                    : item === "Gasflaschentausch"
                                    ? "O"
                                    : item === "Schwimmbad"
                                    ? "s"
                                    : item === "Hallenbad"
                                    ? "S"
                                    : item === "Liegewiese"
                                    ? ";"
                                    : item === "Grillplatz"
                                    ? "b"
                                    : item === "Fahrradverleih"
                                    ? "L"
                                    : item === "Restaurants"
                                    ? "p"
                                    : ""}
                                </p>
                                {item === "Restaurants" ? "Restaurant" : item}
                              </p>
                            </IonLabel>
                          </IonItem>
                        </>
                      );
                    })}
                  </div>
                </IonAccordion>
                <IonAccordion value="third">
                  <IonItem slot="header" className="filter__header__accordion">
                    <IonLabel>
                      <p className="font__uppercase font__small font__red">
                        Untergrund
                      </p>
                    </IonLabel>
                  </IonItem>
                  <div id="underground" className="ion-padding" slot="content">
                    {props.underground.map((item, index) => {
                      let itemChecked = false;
                      if (props.activeFilter.underground.indexOf(item) !== -1) {
                        itemChecked = true;
                      }
                      return (
                        <>
                          <IonItem
                            key={item}
                            className="filter__item__accordion"
                          >
                            <IonCheckbox
                              checked={itemChecked}
                              name={item}
                              value={item}
                              onIonChange={(e) => {
                                let newUndergrounds = [...props.activeFilter.underground];
                                if (e.detail.checked) {
                                  if (newUndergrounds.indexOf(item) === -1) newUndergrounds.push(item);
                                } else {
                                  newUndergrounds = newUndergrounds.filter(f => f !== item);
                                }
                                props.setActiveFilter({ ...props.activeFilter, underground: newUndergrounds });
                              }}
                            ></IonCheckbox>
                            <IonLabel className="ion-padding-start">
                              <p className="font__small font__accordion">
                                {item}
                              </p>
                            </IonLabel>
                          </IonItem>
                        </>
                      );
                    })}
                  </div>
                </IonAccordion>
                <IonAccordion value="fourth">
                  <IonItem slot="header" className="filter__header__accordion">
                    <IonLabel>
                      <p className="font__uppercase font__small font__red">
                        Interessen
                      </p>
                    </IonLabel>
                  </IonItem>
                  <div id="interests" className="ion-padding" slot="content">
                    {props.interestsCat.map((cat) => {
                      return (
                        <>
                          <h5>{cat}</h5>
                          {Object.entries(props.interests[cat]).map(
                            (subitem) => {
                              var subkey = subitem[0];
                              let itemChecked = false;
                              if (
                                props.activeFilter.interests.indexOf(subkey) !== -1
                              ) {
                                itemChecked = true;
                              }
                              return (
                                <>
                                  <IonItem
                                    key={subkey}
                                    className="filter__item__accordion"
                                  >
                                    <IonCheckbox
                                      checked={itemChecked}
                                      name={subkey}
                                      value={subkey}
                                      onIonChange={(e) => {
                                        let newInterests = [...props.activeFilter.interests];
                                        if (e.detail.checked) {
                                          if (newInterests.indexOf(subkey) === -1) newInterests.push(subkey);
                                        } else {
                                          newInterests = newInterests.filter(f => f !== subkey);
                                        }
                                        props.setActiveFilter({ ...props.activeFilter, interests: newInterests });
                                      }}
                                    ></IonCheckbox>
                                    <IonLabel className="ion-padding-start">
                                      <p className="font__small font__accordion">
                                        {subkey}
                                      </p>
                                    </IonLabel>
                                  </IonItem>
                                </>
                              );
                            }
                          )}
                        </>
                      );
                    })}
                  </div>
                </IonAccordion>
              </IonAccordionGroup>
            </IonContent>
          </IonModal>
        </>
      </div>
    </div>
  ) : (
    <></>
  );
}

export default Filter;
